/** @format */

import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Container } from "@chakra-ui/react";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

// TODO - update to Chakra styling?
const PrivacyPolicyPage = (props) => {
  // Ugly, but it should work.
  const location = useLocation();
  const cookieNoticeRef = React.createRef();

  useEffect(() => {
    if (cookieNoticeRef.current && location.hash === "#cookie-notice") {
      window.scrollTo({
        top: cookieNoticeRef.current.offsetTop,
        behavior: "smooth", // smooth scroll.
      });
    }
  }, [location.hash, cookieNoticeRef.current]);

  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Privacy Policy</title>
          <link rel="canonical" href={ absoluteUrl( "/privacy-policy")} />
        </Helmet>
    <Box pt={"78px"}>
      <Container maxW={{ lg: "40%", md: "60%" }}>
        <div className="bk-zone bk-lg ">
          <div className="bk-region">
            <div className="bk-main">
              <div className="bk-block">
                <div className="bk-page-terms-terms-of-use">
                  <div className="bk-zone bk-lg bk-first ">
                    <div className="bk-region">
                      <div className="bk-main">
                        <div className="">
                          <p style={{ textAlign: "left" }}>
                            <strong>WELLTOWER</strong>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <strong>Website Privacy Policy</strong>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Last modified: September 29, 2023
                          </p>
                          <p style={{ textAlign: "left" }}>
                            This Privacy Policy (this “Privacy Policy”)
                            discloses the privacy practices of Welltower Inc.
                            (“Welltower,” “our”, “us” or “we”) of 4500 Dorr
                            Street, Toledo, OH 43615 with respect to our
                            collection and use of United States residents’
                            Personal Information (defined below), including on
                            our websites such as 
                            <a href="https://www.welltower.com/">
                              www.welltower.com
                            </a>
                             and{" "}
                            <a href="https://medicaloffice.welltower.com/">
                              medicaloffice.welltower.com
                            </a>{" "}
                            <span> </span>(collectively, the “Site”).
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Please read this Privacy Policy as it provides
                            important information regarding your use of the
                            Site, our data and privacy practices, and explains
                            your rights. You acknowledge that this Privacy
                            Policy is part of the Terms of Use for the Site (the
                            “Terms of Use”), and by accessing or using the Site,
                            you accept and agree to be bound by the Terms of Use
                            and this Privacy Policy.  If you do not agree to the
                            Terms of Use and this Privacy Policy, please do not
                            access or use the Site.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            We reserve the right to change, revise or modify
                            this Privacy Policy at any time and from time to
                            time without notice to you.  Such changes, revisions
                            or modifications shall be effective immediately when
                            we post them.  You acknowledge and agree that it is
                            your responsibility to review the Site and this
                            Privacy Policy periodically and to be aware of any
                            changes, revisions or modifications.  Your continued
                            use of the Site after such changes, revisions or
                            modifications will constitute your acceptance and
                            acknowledgment of the changed, revised or modified
                            privacy policy and agreement to abide and be bound
                            by it as changed, revised or modified. The date of
                            modification is located above.
                          </p>
                          <ol>
                            <li>
                              <strong>
                                NOTICE AT COLLECTION: PERSONAL INFORMATION
                                COLLECTED
                              </strong>
                              .
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            In order to better provide you with services, we may
                            collect, process and store Personal Information
                            about you and as further described in this Privacy
                            Policy.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Personal information means information that
                            identifies, relates to, describes, is reasonably
                            capable of being associated with, or could be
                            reasonably linked, directly or indirectly, with a
                            particular consumer, device or household (“Personal
                            Information”). It does not include de-identified or
                            aggregate information, or public information
                            lawfully available from governmental records.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            The following list describes the categories of
                            Personal Information we may have collected about you
                            in the past 12 months:
                          </p>
                          <ol style={{ listStyleType: "upper-alpha" }}>
                            <li>
                              Personal identifiers-- <span></span>name, email
                              address, mailing address, phone number and other
                              identifying information; including online
                              identifiers, such as device and browser type,
                              browsing and search history on our Sites, and
                              information regarding interaction with our Site
                              and our advertisements
                            </li>
                            <li>
                              <span>
                                {" "}
                                Demographic information – such as age, date of
                                birth, race, gender, sex, ethnicity,
                                nationality, place of birth, citizenship,
                                immigration status, disability, military and
                                veteran status, marital status and dependent
                                information
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                Commercial information– such as records of
                                personal property, products or services
                                purchased, obtained, or considered, or other
                                purchasing or consuming histories or tendencies
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                Audio or video—such as footage collected using
                                CCTV cameras (only if you visit one of our
                                premises that uses this technology) information
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                Internet and other electronic activity
                                information-- information about your use of
                                systems or devices, including your System or
                                Network ID, IP address, operating system type
                                and version number, manufacturer and model,
                                screen resolution, browser type, browser
                                version, the pages of a Site you visit, the time
                                and date of your access to a Site, unique device
                                identifiers
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                Inferences drawn from personal information– such
                                as individual profiles, preferences,
                                characteristics, behaviors
                              </span>
                            </li>
                          </ol>
                          <ol start="2">
                            <li>
                              <strong>
                                SOURCES FROM WHICH WE COLLECT PERSONAL
                                INFORMATION{" "}
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We may collect Personal Information directly from:
                            you, from your employer, from an agent or third
                            party acting on your behalf, our group companies,
                            business partners, companies we provide services
                            for, publicly available sources, one of our
                            affiliated operating companies, a lead referral
                            service, or a data provider who collected
                            information from you directly or indirectly, from
                            third party data brokers, or from the use of our
                            CCTV cameras for certain premises where they are
                            installed for security purposes.
                          </p>
                          <ol start="3">
                            <li>
                              <strong>
                                NOTICE AT COLLECTION: PURPOSES FOR COLLECTION OF
                                PERSONAL INFORMATION
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            When you engage in certain activities on the Site,
                            such as asking for information or requesting
                            services, we may ask you to provide certain
                            information about yourself by filling out and
                            submitting an online form.  It is completely
                            optional for you to engage in these activities;
                            however, we may ask that you provide us Personal
                            Information. Depending upon the activity, some of
                            the information we ask you to provide are in
                            mandatory fields and some are in voluntary fields. 
                            If you do not provide the mandatory data with
                            respect to a particular activity, you will not be
                            able to engage in that activity.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            We also use Personal Information to monitor or
                            improve our Site; for internal business analysis; to
                            prevent fraud, activities that violate our Terms of
                            Use or other contracts, or that are illegal; and to
                            protect our rights and the rights and safety of our
                            users or others.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            For those who interact with us in a commercial
                            capacity, we use your Personal Information to engage
                            in business transactions with the entity you
                            represent and market to or engage in diligence with
                            the entities you represent.<span>   </span>
                          </p>
                          <ol start="4">
                            <li>
                              <strong>
                                HOW WE SHARE YOUR PERSONAL INFORMATION
                              </strong>
                              .
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We may share information with:
                          </p>
                          <ul>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Professional advisers, including accountancy
                                  and legal firms, in order to provide us with
                                  advice;
                                </em>
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Service providers, including to provide and
                                  support our data management, analytics,
                                  security, buildings and storage systems;
                                </em>
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Third parties, including parties that help us
                                  with analytics and marketing{" "}
                                </em>
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Group companies, for business and operational
                                  purposes;
                                </em>
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Business partners, for business purposes; and
                                </em>
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                <em>
                                  Transaction (merger and acquisition) partners,
                                  including to facilitate the diligence,
                                  negotiation, and completion phases of
                                  transactions contemplated by us, our parent
                                  company, or affiliated operating companies.
                                </em>
                              </span>
                            </li>
                          </ul>
                          <p style={{ textAlign: "left" }}>
                            We provide some of our services through contractual
                            arrangements with affiliates, services providers,
                            partners, and other third parties.  We and our
                            service providers may use your Personal Information
                            to operate our Site and to deliver our services. 
                            Service Providers with whom we share your Personal
                            Information are bound to comply with similar and
                            equally stringent undertakings of privacy and
                            confidentiality.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Occasionally, we may be required to share your
                            Personal Information with third parties for
                            legitimate business purposes, or to comply with
                            legal obligations.  For example, we may share
                            Personal Information when we believe in good faith
                            that an applicable law requires it; at the request
                            of law enforcement, judicial authorities (i.e. upon
                            receipt of a court order or subpoena), appropriate
                            governmental authorities; to detect and protect
                            against fraud, or any technical or security
                            vulnerabilities; to respond to an emergency; or
                            otherwise to protect the rights, property, safety or
                            security of third parties, visitors to our Sites,
                            our businesses, or the public. Additional
                            disclosures of your Personal Information to third
                            parties for legitimate business purposes or to
                            comply with legal obligations may include us
                            sharing:
                          </p>
                          <ul>
                            <li>
                              <span>
                                {" "}
                                Online identifiers with third party providers in
                                order to debug errors in our system
                              </span>
                            </li>
                            <li>
                              <span>
                                {" "}
                                Commercial information with accountancy and
                                legal firms to carry out our obligations arising
                                under our contract with you and to enforce the
                                same
                              </span>
                            </li>
                          </ul>
                          <p style={{ textAlign: "left" }}>
                            We do not grant access to your Personal Information
                            to any other third parties unless we say so in this
                            Privacy Policy or unless the law requires it.
                          </p>
                          <ol start="5">
                            <li>
                              <strong>
                                NOTICE AT COLLECTION: CATEGORIES OF PERSONAL
                                INFORMATION WE SELL OR SHARE AND RELATED
                                INFORMATION
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            <span>
                              When we may engage in digital advertising, we may
                              sell the following categories of Personal
                              Information (according to the broad definition of
                              “sell” under select state privacy laws) or we may
                              share them for purposes of cross-context
                              behavioral advertising: personal identifiers (IP
                              address); and internet or other electronic
                              activity information. {" "}
                            </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <span>
                              These categories of Personal Information are sold
                              to or shared for cross-context behavioral
                              advertising to advertising networks and other
                              companies that facilitate digital advertising. We
                              engage in such sales and sharing to facilitate
                              digital advertising that is able to reach people
                              that are most likely to be interested in the Site
                              we provide.  We do so by{" "}
                            </span>
                            <span>
                              allowing third parties to place cookies or other
                              tracking technologies on our website that may
                              collect information about your online activities
                              over time and across different websites or
                              applications.  For more information about the use
                              of cookies and other tracking technologies, see
                              the Section 12 below. {" "}
                            </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <span>
                              To opt out of such sales and sharing of Personal
                              Information, click here:{" "}
                            </span>
                            <Link to="/opt-out">
                              <span>
                                https://medicaloffice.welltower.com/opt-out
                              </span>
                            </Link>
                            <span>.</span>
                          </p>
                          <ol start="6">
                            <li>
                              <strong>
                                USE OR DISCLOSURE OF SENSITIVE PERSONAL
                                INFORMATION
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We do not use or disclose sensitive Personal
                            Information to create profiles about individuals or
                            for any purposes other than providing our services.
                            <span>  </span>
                          </p>
                          <ol start="7">
                            <li>
                              <strong>
                                NOTICE AT COLLECTION: RETENTION PERIODS
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We retain the categories of Personal Information we
                            collect for the length of time necessary to provide
                            our Site and to comply with legal obligations or to
                            protect our legal rights.<span>  </span>
                          </p>
                          <ol start="8">
                            <li>
                              <strong>
                                DISCLOSURE OF PERSONAL INFORMATION FOR BUSINESS
                                PURPOSES IN THE PAST 12 MONTHS
                              </strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We summarize below the categories of Personal
                            Information that we disclose to others.<span></span>
                          </p>
                          <p> </p>
                          <table style={{ border: "1px" }} width="100%">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <strong>
                                      <u>
                                        Category of Personal Information
                                        Collected
                                      </u>
                                    </strong>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>
                                        <u>
                                          Categories of Third Parties to Whom we
                                          have Disclosed Personal Information
                                          for a Business Purpose
                                        </u>
                                      </strong>
                                    </span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>Personal Identifiers</strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                       Service providers such as IT providers,
                                      SaaS providers, banking providers who
                                      process payments or reimbursements, and
                                      other providers who help us operate our
                                      business, including our Sites and
                                      services;
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Consultants such as business consultants;
                                      and
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Advertising partners (please see the 
                                      <strong>
                                        Categories of Personal Information We
                                        Sell or Share and Related Information
                                        section of this Privacy Policy
                                      </strong>
                                      ).
                                    </span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>Demographic Information </strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      HR service provides and other providers
                                      who help us operate our business.
                                    </span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>Commercial Information</strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Service providers such as IT providers,
                                      SaaS providers, banking providers who
                                      process payments or reimbursements, and
                                      other providers who help us operate our
                                      business, including our Sites and
                                      services;
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Consultants such as business consultants;
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Business teams that work with our clients
                                      and other entities that manage businesses
                                      for us (for example, building managers who
                                      engage with residents or potential
                                      residents); and
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Advertising partners (please see{" "}
                                      <strong>
                                        Categories of Personal Information We
                                        Sell or Share and Related Information
                                        section of this Privacy Policy
                                      </strong>
                                      ).
                                    </span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>
                                        Audio, electronic, visual, thermal,
                                        olfactory, or similar sensory
                                        information 
                                      </strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Service providers such as CCTV system
                                      providers or IT service providers who
                                      manage certain access controls systems
                                      located in certain facilities.
                                    </span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>
                                        Internet and Other Electronic Activity
                                        Information
                                      </strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Service providers such as IT SaaS
                                      providers, service providers who help us
                                      operate our business, marketing providers,
                                      and consultants such as
                                      business consultants or IT consultants.
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Advertising partners (please see the 
                                      <strong>
                                        Categories of Personal Information We
                                        Sell or Share and Related Information
                                      </strong>
                                    </span>{" "}
                                    <span>
                                      <strong>
                                        section of this Privacy Policy
                                      </strong>
                                    </span>
                                    <span>).</span>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="26%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      <strong>
                                        Inferences, preferences, and other
                                        information
                                      </strong>
                                    </span>
                                  </p>
                                </td>
                                <td
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "0.5rem",
                                  }}
                                  width="72%"
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Service providers such as IT SaaS
                                      providers, service providers who manage
                                      our systems, and consultants such as
                                      business consultants; and
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Business teams that work with our clients
                                      and other entities that manage businesses
                                      for us (for example, building managers who
                                      engage with residents or potential
                                      residents).
                                    </span>
                                  </p>
                                  <p style={{ textAlign: "left" }}>
                                    <span>
                                      Advertising partners (please see the 
                                      <strong>
                                        Categories of Personal Information We
                                        Sell or Share and Related Information
                                      </strong>
                                    </span>{" "}
                                    <span>
                                      section of this Privacy Policy).
                                    </span>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p style={{ textAlign: "left" }}>
                            We may also disclose the above categories of
                            Personal Information (i) to our affiliates/group
                            companies, (ii) to comply with federal, state, or
                            local laws; (iii) to comply with a civil, criminal,
                            or regulatory inquiry, investigation, subpoena, or
                            summons by federal, state, or local authorities;
                            (iv) to cooperate with law enforcement agencies
                            concerning conduct or activity that we believe may
                            violate federal, state, or local law, (v) when we
                            sell, transfer or otherwise share some or all of our
                            business or assets, including your Personal
                            Information, in connection with a business
                            transaction (or potential business transaction), or
                            (vi) to professional advisors, such as lawyers,
                            bankers, auditors and insurers, where necessary in
                            the course of the professional services that they
                            render to us.
                          </p>
                          <ol start="9">
                            <li>
                              <strong>
                                UPDATING AND CORRECTING YOUR PERSONAL
                                INFORMATION
                              </strong>
                              .
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We believe you should have the ability to access
                            and, where appropriate, edit the Personal
                            Information that you have provided to us.  You may
                            access and correct your Personal Information and
                            privacy preferences by writing us at:
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Welltower Inc. 4500 Dorr Street Toledo, Ohio
                            43615-4040 Attn: Website Administrator
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Please include your name, address, and/or e-mail
                            address when you contact us. We encourage you to
                            promptly update your Personal Information if it
                            changes.
                          </p>
                          <ol start="10">
                            <li>
                              <strong>SECURITY OF PERSONAL INFORMATION</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We implement and maintain reasonable security
                            appropriate to the nature of the Personal
                            Information that we collect, use, retain, transfer
                            or otherwise process. Our reasonable security
                            program is implemented and maintained in accordance
                            with applicable law and relevant standards.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            While we are committed to developing, implementing,
                            maintaining, monitoring and updating a reasonable
                            information security program, unfortunately, no data
                            transmission over the Internet or any wireless
                            network can be guaranteed to be 100% secure.  Data
                            security incidents and breaches can occur due to
                            vulnerabilities, criminal exploits or other factors
                            that cannot reasonably be prevented.  Accordingly,
                            while our reasonable security program is designed to
                            manage data security risks and thus help prevent
                            data security incidents and breaches, it cannot be
                            assumed that the occurrence of any given incident or
                            breach results from our failure to implement and
                            maintain reasonable security. As a result, while we
                            strive to protect your Personal Information, you
                            acknowledge that (a) there are security and privacy
                            limitations of the Internet which are beyond our
                            control; (b) the security, integrity, and privacy of
                            any and all information and data exchanged between
                            you and us through the Site cannot be guaranteed;
                            and (c) any such information and data may be viewed
                            or tampered with in transit by a third party.
                          </p>
                          <ol start="11">
                            <li>
                              <strong>MARKETING</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We endeavor to adhere to self-regulatory advertising
                            principles, such as the Digital Advertising
                            Alliance’s Principles. If you are interested in
                            learning more about and/or opting out of online
                            behavioral advertising, sometimes called
                            interest-based advertising, we encourage you to
                            visit one of the advertising industry-developed
                            opt-out pages, such as 
                            <a href="https://www.youradchoices.com/">
                              www.youradchoices.com
                            </a>
                             or 
                            <a href="https://www.aboutads.info/">
                              aboutads.info
                            </a>
                            . Please note that while we provide these links for
                            your convenience, we do not have access to, or
                            control over, these third parties’ use of cookies or
                            other tracking technologies.
                          </p>
                          <ol start="12">
                            <li id="cookie-notice" ref={cookieNoticeRef}>
                              <strong>COOKIES AND ANALYTICS</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We use cookies, pixel tags, web beacons and other
                            similar tracking technologies (“tracking
                            technologies”) to automatically collect information
                            through our Site. Tracking technologies are
                            essentially small data files placed on your
                            computer, tablet, mobile phone, or other devices
                            that record certain pieces of information when you
                            visit our Site. We may use these tracking
                            technologies to help identify irregular behavior,
                            prevent fraudulent activity and improve security, as
                            well as making it possible for you to save your
                            preferences and help us understand how you interact
                            with our Site.<span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <span>
                              We also allow third parties to use tracking
                              technologies on our Site for analytics and
                              advertising.  They assist in helping display
                              advertisements, tailor advertisements to your
                              interests and to assist in determining if you
                              require assistance or are having problems
                              navigating on our Site.  {" "}
                            </span>
                            <span>
                              Some of these third parties are our service
                              providers that may use certain technologies to
                              record your interactions with the sites, including
                              without limitation, your keystrokes and mouse
                              clicks, and information about when, how and from
                              where you accessed our sites.  This information is
                              used to help us manage our sites and provide a
                              good user experience.  The service providers we
                              use in this regard agree not to sell or disclose
                              any of the recorded information to third parties
                              (other than subcontractors who assist in providing
                              this service to us or for legal compliance
                              purposes at our direction).  Other{" "}
                            </span>
                            <span>
                              third parties use the tracking technologies to
                              collect information about how you interact with
                              other website and advertisements across the
                              Internet to provide advertising that is tailored
                              to your interests and which may appear on our Site
                              or on other website or platforms.{" "}
                            </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <span>
                              You may set your browser to notify you when you
                              receive a cookie. Many web browsers also allow you
                              to block cookies. You can disable cookies from
                              your computer system by following the instructions
                              on your browser or at{" "}
                            </span>
                            <a href="http://www.allaboutcookies.org/">
                              <span>www.youradchoices.com</span>
                            </a>
                            <span>.</span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            We use Google Analytics to evaluate the use of our
                            Site. Google Analytics uses cookies and other
                            identifiers to collect information, such as how
                            often users visit a Site, what pages they visit when
                            they do so, and what other websites they visited
                            prior to visiting our Site. For information about
                            Google’s privacy practices, please refer to the
                            Google Privacy Policy:{" "}
                            <a href="https://policies.google.com/privacy?hl=en-US#infocollect">
                              https://policies.google.com/privacy?hl=en-US#infocollect
                            </a>
                            .
                          </p>
                          <ol start="13">
                            <li>
                              <strong>THIRD PARTY SITES AND LINKS</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            Except as otherwise discussed in this Privacy
                            Policy, this document only addresses our collection,
                            use and disclosure of Personal Information. Other
                            sites accessible through the Site have their own
                            privacy policies and data collection, use, and
                            disclosure practices.  Please consult each site’s
                            privacy policy.  We are not responsible for the
                            policies or practices of third parties.
                          </p>
                          <ol start="14">
                            <li>
                              <strong>DO NOT TRACK SIGNALS</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            While our Site may respect Global Privacy Control
                            signals where required, our Sites do not respond to
                            or honor other Do Not Track instructions, which are
                            preferences that users can set in certain web
                            browsers. If you do not leverage the Global Privacy
                            Control signal, you can, however, adjust your web
                            browser’s privacy preferences regarding the use of
                            most cookies, through your browser’s privacy
                            settings. Unless you choose to block cookies, some
                            of our Sites may issue cookies when you visit them
                            or click on an e-mail link that we send to you, even
                            if you have previously deleted our cookies. Deleting
                            or blocking cookies may impact your experience while
                            interacting with the Site, and some features may not
                            work without cookies.
                          </p>
                          <ol start="15">
                            <li>
                              <strong>CHILDREN’S PRIVACY</strong>.
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            Our Site is not designed for, and we do not
                            knowingly collect personally identifiable
                            information from, users under the age of 13 (or in
                            some jurisdictions, under the age of 16). If you are
                            a parent or guardian and you are aware that your
                            child has provided us with Personal Information via
                            our Site(s), please contact us via email at:
                            <span>  </span>
                            <a href="mailto:legalnotice@welltower.com">
                              legalnotice@welltower.com
                            </a>
                            . If we become aware that we have collected Personal
                            Information from anyone under the age of 13 (or in
                            some jurisdictions, 16) without verification of
                            parental consent, we will take steps to remove it
                            from our systems.
                          </p>
                          <ol start="16">
                            <li>
                              <strong>
                                CALIFORNIA RESIDENT INFORMATION AND RIGHTS
                              </strong>
                              .
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            If you are a resident of the U.S. state of
                            California, you have certain rights granted by the
                            California Consumer Privacy Act <span> </span>and
                            the amendments thereto under the California Privacy
                            Rights Act (collectively, “CCPA”), which are
                            described in this section of the Privacy Policy.
                            This portion of the Privacy Policy describes the
                            rights of California residents. <span> </span>Terms
                            not defined in this Section 16, shall have the
                            meanings set forth to them in the CCPA.
                            <span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Please note, this portion of the Privacy Policy does
                            not include Personal Information that is exempted
                            from the CCPA.
                          </p>
                          <h2>
                            <strong>A.             </strong>
                            <strong>
                              Individual Rights of California Residents
                            </strong>
                          </h2>
                          <p style={{ textAlign: "left" }}>
                            As a California Resident you have certain rights in
                            relation to your Personal Information.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <strong>
                              <em>
                                Your Right to Request Disclosure of Information
                                We Collect and Share About You
                              </em>
                            </strong>
                            . We are committed to ensuring that you know what
                            Personal Information we collect. To that end, you
                            can ask us for any or all of following types of
                            information regarding the Personal Information we
                            have collected about you on or after January 1,
                            2022:
                          </p>
                          <ul>
                            <li>
                              Specific pieces of Personal Information we have
                              collected about you;
                            </li>
                            <li>
                              Categories of Personal Information we have
                              collected about you;
                            </li>
                            <li>
                              Categories of sources from which such Personal
                              Information was collected;
                            </li>
                            <li>
                              Categories of Personal Information that the
                              business sold, shared, or disclosed for a business
                              purpose about the consumer;
                            </li>
                            <li>
                              Categories of third parties to whom the Personal
                              Information was sold, shared, or disclosed for a
                              business purpose; and
                            </li>
                            <li>
                              The business or commercial purpose for collecting
                              or selling your Personal Information.
                            </li>
                          </ul>
                          <p style={{ textAlign: "left" }}>
                            <strong>
                              <em>
                                Your Right to Correct Inaccurate Personal
                                Information
                              </em>
                            </strong>
                            .<strong> </strong>You have the right to request
                            that we correct Personal Information we hold that
                            you believe is not accurate.<span>  </span>We will
                            take steps to determine the accuracy of the Personal
                            Information that is the subject of your request to
                            correct, and in doing so will consider the totality
                            of the circumstances relating to the Personal
                            Information you have identified as being incorrect.
                            <span>  </span>We may ask that you provide
                            documentation regarding your request to correct in
                            order to assist us in evaluating the request.
                            <span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <strong>
                              <em>
                                Your Right to Request Deletion of Personal
                                Information We Collected About You
                              </em>
                            </strong>
                            .<strong> </strong>Upon your request, we will delete
                            the Personal Information we have collected about
                            you, subject to certain legal exceptions.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <strong>
                              <em>
                                Your<span>  </span>Right to Ask Us Not to Sell
                                or Share Personal Information We Have Collected
                                About You
                              </em>
                            </strong>
                            <em>. </em>With respect to those categories of
                            Personal Information that we sell to third parties
                            or share with third parties for the purpose of
                            cross-context behavioral advertising, you have the
                            right to opt out of such sales and sharing.
                            <span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            With respect to those categories of Personal
                            Information that we sell to third parties or share
                            with third parties for the purpose of cross-context
                            behavioral advertising, you have the right to opt
                            out of such sales and sharing.<span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <em>Opt-out Preference Signals </em>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            An opt-out preference signal is sent by a platform,
                            technology, or mechanism on behalf of consumers and
                            communicates a consumer’s choice to opt out of the
                            sale and sharing of personal information for
                            cross-context behavioral advertising with all
                            businesses that recognize the signal, without having
                            to make individualized requests.<span>  </span>The
                            signal can be set on certain browsers or through
                            opt-out plug-in tools.<span>  </span>
                          </p>
                          <p style={{ textAlign: "left" }}>
                            We recognize the Global Privacy Control signal and
                            do so at the browser level.<span>  </span>This means
                            that if the signal is sent through a specific
                            browser, we will recognize it for that browser only.
                            <span>  </span>If you would like more information
                            about opt-out preference signals, including how to
                            use them, the Global Privacy Control website has
                            such information
                            (https://globalprivacycontrol.org/).
                          </p>
                          <h2>
                            <strong>B.             </strong>
                            <strong>
                              Making a Request and How We Handle a Request to
                              Exercise Your Rights
                            </strong>
                          </h2>
                          <p style={{ textAlign: "left" }}>
                            To make a request, please call us at 877-670-0070 or{" "}
                            <a href="mailto:legalnotice@welltower.com">
                              legalnotice@welltower.com
                            </a>
                            .  <span> </span>For requests for access or
                            deletion, we will first acknowledge receipt of your
                            request within 10 days of receipt of your
                            request.  We provide a substantive response to your
                            request as soon as we can, generally within 45 days
                            from when we receive your request, although we may
                            be allowed to take longer to process your request in
                            certain jurisdictions or under certain
                            circumstances.  If we expect your request is going
                            to take us longer than normal to fulfil, we’ll let
                            you know.  We usually act on requests and provide
                            information free of charge, but we may charge a
                            reasonable fee to cover our administrative costs of
                            providing the information in certain situations. In
                            some cases, the law may allow us to refuse to act on
                            certain requests.  When this is the case, we will
                            endeavor to provide you with an explanation as to
                            why.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            You can direct us not to sell your Personal
                            Information or share it for purposes of
                            cross-context behavioral advertising at{" "}
                            <a href="https://welltower.com/opt-out">
                              <span>https://welltower.com/opt-out</span>
                            </a>
                            .<span>  </span>For such requests, we will comply no
                            later than 15 business days after receipt of your
                            request.<span>  </span>
                          </p>
                          <h2>
                            <strong>C.             </strong>
                            <strong>
                              How We Verify Your Identity When You Submit an
                              Access, Correct or Deletion Request
                            </strong>
                          </h2>
                          <p style={{ textAlign: "left" }}>
                            <em>Individual Requests. </em>We will ask California
                            residents for two pieces of identifying information
                            and attempt to match it to information that we
                            maintain about<span>  </span>them in order to verify
                            their request. Additionally, depending on the nature
                            of your request, we may require that you provide a
                            declaration attesting to your identity, signed under
                            penalty of perjury. If we are unable to verify your
                            identity with a degree of certainty required, we
                            will not be able to fulfil to the request.  We will
                            notify you to explain the basis of the denial.
                            Additionally, we will treat the request as one
                            seeking disclosure of the categories of Personal
                            Information we have collected about you and endeavor
                            to verify your identity using the less-stringent
                            standards applicable to such requests.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            If we are unable to verify your identity with the
                            degree of certainty required, we will not be able to
                            respond to your request.<span>  </span>We will
                            notify you to explain the basis of the denial.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <em>
                              Authorized Agents – Additional Verification
                              Required.  
                            </em>
                            You may designate an agent to submit requests on
                            your behalf.  The agent can be a natural person or a
                            business entity that is registered with the
                            California Secretary of State.   If you would like
                            to designate an agent to act on your behalf, you and
                            the agent will need to comply with our agent
                            verification process to verify your identity and
                            provide us with proof of the agency relationship.
                          </p>
                          <ul>
                            <li>
                              <u>
                                Requests to Access, Delete or Correct Personal
                                Information:{" "}
                              </u>
                              If the agent submits a request, the agent will
                              need to provide us with your signed permission
                              indicating the agent has been authorized to submit
                              the request on your behalf.<span>  </span>We will
                              also require that you verify your identity
                              directly with us or confirm with us that you
                              provided the agent with permission to submit the
                              request.
                            </li>
                            <li>
                              <u>Requests to Opt Out of Sale or Sharing: </u>If
                              the agent submits a request to opt out of the sale
                              of your Personal Information or the sharing of
                              your personal information for purposes of
                              cross-context behavioral marketing, the agent will
                              need to provide us with your signed permission
                              indicating the agent has been authorized to submit
                              the opt-out request on your behalf.<span>  </span>
                            </li>
                          </ul>
                          <p style={{ textAlign: "left" }}>
                            Please note that this subsection does not apply when
                            an agent is authorized to act on your behalf
                            pursuant to a valid power of attorney.  Any such
                            requests will be processed in accordance with
                            California law pertaining to powers of attorney.
                          </p>
                          <p style={{ textAlign: "left" }}>
                            <em>Household Requests</em> — There may be some
                            types of Personal Information that can be associated
                            with a household (a group of people living together
                            in a single dwelling). Requests for access or
                            deletion of household Personal Information must be
                            made by each member of the household. We will verify
                            each member of the household using the verification
                            criteria explained above.  If we are unable to
                            verify the identity of each household member with
                            the degree of certainty required, we will not be
                            able to respond to the request. We will notify you
                            to explain the basis of our denial.
                          </p>
                          <h2>
                            <strong>D.             </strong>
                            <strong>
                              Our Commitment to Honoring Your Rights
                            </strong>
                          </h2>
                          <p style={{ textAlign: "left" }}>
                            If you exercise any of the rights explained in this
                            Privacy Policy, we will continue to treat you
                            fairly.  If you exercise your rights under this
                            Privacy Policy, you will not be denied or charged
                            different prices or rates for goods or services, or
                            provided a different level or quality of goods or
                            services than others.
                          </p>
                          <h2>
                            <strong>E.              </strong>
                            <strong>California Shine the Light</strong>
                          </h2>
                          <p style={{ textAlign: "left" }}>
                            California Civil Code Section 1798.83, also known as
                            the “Shine The Light” law, permits California
                            residents to annually request, free of charge,
                            information about the Personal Information (if any)
                            disclosed to third parties for direct marketing
                            purposes in the preceding calendar year.
                          </p>
                          <ol start="17">
                            <li>
                              <strong>CONTACT US</strong>
                              <strong>.</strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            If you have questions on the processing of your
                            Personal Information, please contact us here: 
                            <a href="mailto:legalnotice@welltower.com">
                              legalnotice@welltower.com
                            </a>
                             or call us toll free at 877-670-0070, or write us
                            at:
                          </p>
                          <p style={{ textAlign: "left" }}>Welltower Inc.</p>
                          <p style={{ textAlign: "left" }}>4500 Dorr Street</p>
                          <p style={{ textAlign: "left" }}>
                            Toledo, Ohio 43615-4040
                          </p>
                          <p style={{ textAlign: "left" }}>
                            Attn: Data Privacy Officer
                          </p>
                          <ol start="18">
                            <li>
                              <strong>
                                ACCESSIBILITY OF OUR COMMUNICATIONS
                              </strong>
                              <strong>.</strong>
                            </li>
                          </ol>
                          <p style={{ textAlign: "left" }}>
                            We are committed to ensuring that our communications
                            are accessible to people with disabilities. To make
                            accessibility-related requests or report barriers,
                            please contact us at 877-670-0070 or contact 
                            <a href="mailto:legalnotice@welltower.com">
                              legalnotice@welltower.com
                            </a>
                            .<strong> </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Box>
        </>
  );
};

export default PrivacyPolicyPage;
